var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { treeMenuContext } from "@whitespace/components/src/contexts";
import clsx from "clsx";
import React, { useContext } from "react";
import { filterAttributes } from "../utils";
import TreeMenuItem from "./TreeMenuItem";
export default function TreeMenuList(_a) {
  var _b = _a,
    {
      expanded = true,
      items,
      parentPath = []
    } = _b,
    restProps = __objRest(_b, ["expanded", "items", "parentPath"]);
  const {
    styles
  } = useContext(treeMenuContext);
  if (items.length === 0) {
    return null;
  }
  let attributes = filterAttributes(restProps);
  return /* @__PURE__ */React.createElement("ul", __spreadValues({
    className: clsx(styles.list, parentPath.length > 0 && styles.sublist),
    hidden: !expanded
  }, attributes), items.map((item, index) => {
    return /* @__PURE__ */React.createElement(TreeMenuItem, {
      path: [...parentPath, index],
      key: index,
      item
    });
  }));
}